import React from 'react';

export interface PermissionsContextValues {
	canRoles?: {
		create?: boolean;
		edit?: boolean;
		delete?: boolean;
	};
	canPermissions?: {
		addToRole?: boolean;
		deleteFromRole?: boolean;
	};
}

export const PermissionsContext = React.createContext<PermissionsContextValues>({});

export const PermissionsProvider = PermissionsContext.Provider;
